import { CircularProgress, Stack } from "@mui/material"
import { useEffect } from "react"
import { rootStore, useStores } from "stores/root-store"
import { MainComponent, ContentWrapper, AppLoadingContainer } from "components/common-styles"
import { useParams } from "react-router-dom"
import BreadcrumbHeader from "components/common/breadcrumb-header"
import ProductInfo from "components/inventory/details/product-info"
import ProductHistory from "components/inventory/details/product-history"
import { observer } from "mobx-react-lite"
import InventoryForm from "components/inventory/dialog/inventory-form"

const InventoryDetail = () => {
  const { productId } = useParams()

  const { InventoryStore } = useStores()

  useEffect(() => {
    InventoryStore.loadDetailData(productId)
  }, [InventoryStore, productId, InventoryStore.forceReload])

  if (InventoryStore.isLoading || !InventoryStore.productInformation) {
    return (
      <AppLoadingContainer>
        <CircularProgress size={64} />
      </AppLoadingContainer>
    )
  }

  const onEditClicked = () => {
    rootStore.setOpenForm(true)
  }

  const handleClose = () => {
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    InventoryStore.setForceReload()
  }

  if (rootStore.openForm) return <InventoryForm onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <BreadcrumbHeader />
      <MainComponent component="main">
        <ContentWrapper maxWidth={"xl"}>
          <Stack spacing={2}>
            <ProductInfo onEditClicked={onEditClicked} />
            <ProductHistory />
          </Stack>
        </ContentWrapper>
      </MainComponent>
    </>
  )
}

export default observer(InventoryDetail)
